export class PerformanceChartAPI {
  constructor(config) {
    this.config = config;
  }
  async loadData(startDate = null, endDate = null) {
    const endpointUrl = new URL(this.config.endpoint);
    if ((startDate && startDate !== "all") || (endDate && endDate !== "all")) {
      endpointUrl.search = new URLSearchParams({
        startDate,
        endDate,
      });
    }

    const response = await fetch(endpointUrl);
    return await response.json();
  }
}
